(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('CompanyCustomerCustom', CompanyCustomerCustom);

    CompanyCustomerCustom.$inject = ['$resource', 'ENV'];

    function CompanyCustomerCustom($resource,ENV) {


        var getCompanyCustomerByCurrentCompany = function () {
            var resourceUrl = 'api/get-company-customer-by-current-company';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };
        var getCompanyCustomForm = function (companyId) {

            var resourceUrl = 'api/get-company-custom-form-by-company-id?companyId=' + companyId;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };
        var getCompanyCustomFormDataByCompanyCustomerId = function (companyCustomerId) {

            var resourceUrl = 'api/get-company-custom-form-data-by-company-customer-id?companyCustomerId=' + companyCustomerId;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };
        var getCompanyCustomerByCustomerId = function (customerId) {

            var resourceUrl = 'api/get-company-custom-form-data-by-customer-id?customerId=' + customerId;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };
        var getNewCompanyCustomerFormData = function (companyCustomFormId) {

            var resourceUrl = 'api/get-new-company-customer-form-data-by-company-custom-form-id?companyCustomFormId=' + companyCustomFormId;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };

        // var getCompanyCustomerFormData = function (id) {
        //
        //     var resourceUrl = 'api/get-company-customer-form-data?Id='+id;
        //     return $resource(resourceUrl, {}, {
        //             'query': {method: 'GET', isArray: true}
        //         }
        //     );
        // };

        var addNewCustomer = function () {
            var resourceUrl = 'api/add-new-customer';
            return $resource(resourceUrl, {}, {}
            );
        }

        var companyCustomerFormData = function () {
            var resourceUrl = 'api/company-customer-form-data/:id';
            // return $resource(resourceUrl, {}, {}
            // );
            return $resource(resourceUrl, {}, {
                'query': {method: 'GET', isArray: true},
                'get': {
                    method: 'GET',
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                        }
                        return data;
                    }
                },
                'update': {method: 'PUT'}
            });
        }
        var editCompanyCustomerFormData = function () {
            var resourceUrl = 'api/edit-company-customer-form-data';
            return $resource(resourceUrl, {}, {}
            );
        }


        var updateCompanyCustomer = function () {
            var resourceUrl = 'api/update-company-customer';
            return $resource(resourceUrl, {}, {}
            );
        }

        var updateCustomerIntakeFormData = function () {
            var resourceUrl = 'api/update-customer-intake-form-data';
            return $resource(resourceUrl, {}, {}
            );

        }

        var getAllCompanyCustomers = function () {

            var resourceUrl = 'api/get-all-company-customers';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };

        // var getCompanyCustomerWithForms = function (companyCustomerId) {
        //
        //     var resourceUrl = 'api/get-company-customer-with-forms-by-id?companyCustomerId='+companyCustomerId;
        //     return $resource(resourceUrl, {}, {
        //             'query': {method: 'GET', isArray: true}
        //         }
        //     );
        // };

        var getEmptyCompanyCustomerIntakeData = function () {

            var resourceUrl = 'api/get-empty-company-customer-intake-data';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };

        var findCompanyCustomerByCustomerId = function (customerId) {

            var resourceUrl = 'api/get-company-customer-by-customer-id?customerId=' + customerId;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };

        var getAllCompanyCustomForm = function () {

            var resourceUrl = 'api/get-all-company-custom-form';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };

        var sendWelcomeMessage = function(customerId) {
            var resourceUrl = 'api/company-customers/' + customerId + '/welcome';
            return $resource(resourceUrl, {}, {});
        }

        var mergeCompanyCustomers = function () {
               var resourceUrl =
                   ENV.API_BASE_URL +
                   'api/company-customers/merge';

               return $resource(resourceUrl, {}, {
                   merge: {
                       method: 'POST',
                       isArray: false
                   }
               });
           };
        var getCompanyCustomerDuplicates = function () {
            var resourceUrl = 'api/company-customers/duplicates';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };


        return {
            getCompanyCustomerByCurrentCompany: getCompanyCustomerByCurrentCompany,
            addNewCustomer: addNewCustomer,
            updateCompanyCustomer: updateCompanyCustomer,
            updateCustomerIntakeFormData: updateCustomerIntakeFormData,
            getCompanyCustomForm: getCompanyCustomForm,
            getCompanyCustomFormDataByCompanyCustomerId: getCompanyCustomFormDataByCompanyCustomerId,
            getCompanyCustomerByCustomerId: getCompanyCustomerByCustomerId,
            getNewCompanyCustomerFormData: getNewCompanyCustomerFormData,
            companyCustomerFormData: companyCustomerFormData,
            getAllCompanyCustomers: getAllCompanyCustomers,
            getEmptyCompanyCustomerIntakeData: getEmptyCompanyCustomerIntakeData,
            findCompanyCustomerByCustomerId: findCompanyCustomerByCustomerId,
            getAllCompanyCustomForm: getAllCompanyCustomForm,
            sendWelcomeMessage: sendWelcomeMessage,
            mergeCompanyCustomers:mergeCompanyCustomers,
            getCompanyCustomerDuplicates: getCompanyCustomerDuplicates


        };
    }
})();
